export const product = {
  name: 'El Puente del Adiós',
  headline: 'El Puente del Adiós',
  subheadline:
    'Un sistema completo para acompañar el duelo desde los 6 hasta los 18 años',
  description: [
    '4 tomos + 30 tarjetas + 3 bonos, con recursos diferenciados para niños, adolescentes y familias.',
    'Desde las primeras horas del impacto hasta la expresión, el diálogo y la construcción de nuevos significados.',
  ],
  cta: 'Quiero acceder a El Puente del Adiós',
  listPrice: '$16.990 ARS',
  price: '$9.990 ARS',
}

export const checkoutUrl = 'https://el-puente-del-adios.impultienda.ar'

export const heroImage =
  'https://cdn.magicpatterns.com/uploads/5TWQWnsCn23Xi6TACHi62k/mockup-oferta.png'

export const heroBullets: string[] = [
  'Niños de 6 a 12 años',
  'Adolescentes de 13 a 18 años',
  '200+ páginas de recursos',
  '30 tarjetas terapéuticas',
  'Acceso inmediato y uso ilimitado',
]

export const stats = [
  { value: '4', label: 'Tomos completos' },
  { value: '30', label: 'Tarjetas terapéuticas' },
  { value: '200+', label: 'Páginas de recursos' },
  { value: '6–18', label: 'Años de cobertura' },
]

export const problemQuestions: string[] = [
  '¿Qué digo?',
  '¿Qué debería evitar?',
  '¿Cómo hablo de lo que pasó según su edad?',
  '¿Qué hago cuando no quiere hablar?',
  '¿Cómo facilito una conversación sin presionar?',
  '¿Cómo acompaño también a la familia?',
]

export interface Category {
  label: string
  dot: string
}

export const cardCategories: Category[] = [
  { label: 'Pensamientos', dot: 'bg-plum-700' },
  { label: 'Emociones', dot: 'bg-plum-300' },
  { label: 'Conductas', dot: 'bg-teal-500' },
  { label: 'Culpa', dot: 'bg-gold-500' },
  { label: 'Significado', dot: 'bg-plum-600' },
  { label: 'Futuro', dot: 'bg-gold-300' },
]

export const cardExamples: string[] = [
  'Cuando recordás a [nombre], ¿qué es lo primero que aparece en tu mente?',
  '¿Hay algo de [nombre] que quieras conservar como parte de tu vida? ¿Cómo?',
]

export interface Volume {
  tag: string
  title: string
  subtitle: string
  intro: string
  items: string[]
  value: string
  accent: string
  chip: string
}

export const volumes: Volume[] = [
  {
    tag: 'Tomo 1',
    title: 'Protocolo Primeras Horas',
    subtitle: 'Qué decir, qué evitar y cómo acompañar las primeras 72 horas',
    intro:
      'Una guía para los primeros momentos, cuando aparece la pregunta “¿y ahora qué hago?”. Orientaciones concretas según la edad, para no empezar desde cero.',
    items: [
      'Qué decir y qué expresiones conviene evitar',
      'Cómo comunicar según la edad',
      'Diferencias entre niños y adolescentes',
      'Cómo acompañar distintas respuestas emocionales',
      'Qué hacer cuando aparecen preguntas difíciles',
      'Cómo sostener sin presionar',
      'Orientaciones para las primeras 72 horas',
    ],
    value: 'Valor individual: $3.990',
    accent: 'bg-plum-700',
    chip: 'bg-plum-50 text-plum-700',
  },
  {
    tag: 'Tomo 2',
    title: 'Mi Mapa del Adiós',
    subtitle: '20 dinámicas gráficas para niños de 6 a 12 años',
    intro:
      'Otras formas de expresión para aquello que un niño todavía no puede poner en palabras. No se trata de obligarlo a hablar, sino de ofrecerle caminos.',
    items: [
      '20 dinámicas listas para utilizar',
      'Dibujo, escritura y actividades gráficas',
      'Expresión de emociones',
      'Trabajo sobre recuerdos y vínculos importantes',
      'Espacios de expresión personal',
      'Material listo para imprimir',
    ],
    value: 'Valor individual: $2.990',
    accent: 'bg-teal-500',
    chip: 'bg-teal-50 text-teal-600',
  },
  {
    tag: 'Tomo 3',
    title: 'Diario de Resiliencia',
    subtitle: 'Introspección y escritura para adolescentes de 13 a 18 años',
    intro:
      'Un espacio más privado y maduro para adolescentes que prefieren procesar lo que sienten a través de la escritura y la introspección.',
    items: [
      'Disparadores de escritura',
      'Preguntas de introspección',
      'Culpa y preguntas difíciles',
      'Recuerdos y vínculo',
      'Cambios después de una pérdida',
      'Identidad, valores y futuro',
      'Espacios privados de escritura',
    ],
    value: 'Valor individual: $3.990',
    accent: 'bg-gold-500',
    chip: 'bg-gold-50 text-gold-700',
  },
  {
    tag: 'Tomo 4',
    title: '30 Cartas para Sanar',
    subtitle: '30 tarjetas de exploración terapéutica basadas en principios TCC',
    intro:
      'A veces no necesitás una actividad completa, sino una pregunta que abra la conversación. 30 tarjetas organizadas en 6 áreas de exploración:',
    items: [
      '30 tarjetas en alta resolución',
      '6 áreas de exploración',
      'Diseño profesional, listas para imprimir',
      'Disparadores para espacios profesionales, educativos o familiares',
      'Lenguaje adaptable a la edad y al contexto',
    ],
    value: 'Valor individual: $1.990',
    accent: 'bg-plum-300',
    chip: 'bg-plum-50 text-plum-600',
  },
]

export interface Bonus {
  tag: string
  title: string
  subtitle: string
  description: string
  items?: string[]
  itemsLabel?: string
  badge: string
}

export const bonuses: Bonus[] = [
  {
    tag: 'Bono #1',
    title: 'Ruta Rápida del Duelo',
    subtitle: 'Guía para saber por dónde empezar',
    description:
      'Una orientación sencilla para ordenar los primeros pasos cuando ya tenés las herramientas frente a vos, pero necesitás claridad para comenzar.',
    badge: 'Hoy incluido',
  },
  {
    tag: 'Bono #2',
    title: 'Rituales Simbólicos de Despedida',
    subtitle: '12 recursos sensibles para recordar, expresar y acompañar',
    description:
      '12 propuestas simbólicas para generar espacios de recuerdo, expresión y despedida. Respetuosas, sin dramatizar ni imponer una única manera de vivir el proceso.',
    badge: 'Hoy incluido',
  },
  {
    tag: 'Bono #3',
    title: 'Guía para Familias: Acompañar sin Lastimar',
    subtitle: 'Qué decir, qué evitar y cómo sostener en el duelo',
    description:
      'El acompañamiento continúa en casa. Muchas familias quieren ayudar, pero no saben qué decir.',
    itemsLabel: 'Les ofrece orientación para:',
    items: [
      'Acompañar sin presionar',
      'Escuchar con mayor sensibilidad',
      'Evitar frases que pueden resultar poco útiles',
      'Validar diferentes formas de sentir',
      'Estar presentes incluso cuando no encuentran las palabras',
    ],
    badge: 'Hoy incluido',
  },
]

export interface Path {
  title: string
  steps: string[]
  connector: '↓' | '+'
  description: string
}

export const paths: Path[] = [
  {
    title: 'Para niños de 6 a 12 años',
    steps: ['Protocolo Primeras Horas', 'Mi Mapa del Adiós', 'Cartas para Sanar'],
    connector: '↓',
    description: 'Más dibujo, expresión y recursos visuales.',
  },
  {
    title: 'Para adolescentes de 13 a 18 años',
    steps: ['Protocolo Primeras Horas', 'Diario de Resiliencia', 'Cartas para Sanar'],
    connector: '↓',
    description: 'Más introspección, escritura y privacidad.',
  },
  {
    title: 'Para las familias',
    steps: ['Guía para Familias', 'Rituales Simbólicos de Despedida'],
    connector: '+',
    description: 'Para acompañar también fuera del espacio profesional o educativo.',
  },
]

export const includedItems: string[] = [
  'TOMO 1: Protocolo Primeras Horas',
  'TOMO 2: Mi Mapa del Adiós',
  'TOMO 3: Diario de Resiliencia',
  'TOMO 4: 30 Cartas para Sanar',
  'BONO 1: Ruta Rápida del Duelo',
  'BONO 2: Rituales Simbólicos de Despedida',
  'BONO 3: Guía para Familias — Acompañar sin Lastimar',
]

export const totalFacts: string[] = [
  '200+ páginas',
  'Edades: 6 a 18 años',
  'Digital, listo para imprimir',
]

export interface ValueLine {
  label: string
  value: string
  free?: boolean
}

export const valueStack: ValueLine[] = [
  { label: 'Tomo 1 — Protocolo Primeras Horas', value: '$3.990' },
  { label: 'Tomo 2 — Mi Mapa del Adiós', value: '$2.990' },
  { label: 'Tomo 3 — Diario de Resiliencia', value: '$3.990' },
  { label: 'Tomo 4 — 30 Cartas para Sanar', value: '$1.990' },
  { label: 'Bono 1 — Ruta Rápida del Duelo', value: 'Incluido', free: true },
  { label: 'Bono 2 — Rituales Simbólicos de Despedida', value: 'Incluido', free: true },
  { label: 'Bono 3 — Guía para Familias', value: 'Incluido', free: true },
]

export const ctaBullets: string[] = [
  'Acceso digital inmediato',
  'Material listo para imprimir',
  'Garantía de 7 días',
]

export const contexts: string[] = [
  'Consultorios',
  'Escuelas',
  'Orientación educativa',
  'Talleres',
  'Espacios familiares',
]

export interface FaqItem {
  question: string
  answer: string[]
}

export const faqs: FaqItem[] = [
  {
    question: '¿Cómo recibo el material?',
    answer: [
      'Una vez confirmado el pago, recibirás el acceso digital para descargar los archivos.',
    ],
  },
  {
    question: '¿Es material físico?',
    answer: [
      'No. Es un producto 100% digital: descargás los archivos e imprimís los recursos que necesites.',
    ],
  },
  {
    question: '¿Necesito ser psicólogo/a?',
    answer: [
      'No necesariamente. Puede utilizarse como recurso de apoyo por profesionales, docentes, orientadores y familias, respetando los límites de cada contexto.',
      'No sustituye evaluación, diagnóstico ni tratamiento psicológico profesional.',
    ],
  },
  {
    question: '¿Qué edades cubre?',
    answer: [
      'Niños: 6 a 12 años. Adolescentes: 13 a 18 años.',
      'Cada tomo ofrece diferentes formas de expresión según la etapa.',
    ],
  },
  {
    question: '¿Tengo que utilizar todos los tomos juntos?',
    answer: [
      'No. Podés seleccionar los recursos según la edad y la situación.',
      '6–12: Protocolo + Mi Mapa del Adiós + Cartas. 13–18: Protocolo + Diario de Resiliencia + Cartas. Los bonos complementan el acompañamiento.',
    ],
  },
  {
    question: '¿Puedo imprimir las tarjetas y actividades?',
    answer: [
      'Sí. Las tarjetas y los recursos imprimibles están preparados para descargarlos e imprimirlos.',
    ],
  },
  {
    question: '¿Reemplaza la terapia?',
    answer: [
      'No. Es un conjunto de materiales educativos y de apoyo.',
      'Ante síntomas graves, riesgo de autolesión, ideación suicida u otra urgencia, corresponde recurrir a profesionales y servicios de emergencia.',
    ],
  },
]

export const closingNeeds: string[] = [
  'Qué utilizar con un niño.',
  'Qué utilizar con un adolescente.',
  'Qué preguntar.',
  'Cómo facilitar la expresión.',
  'Cómo acompañar a la familia.',
  'Y por dónde empezar.',
]
